"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _uiUtils = require("@airasia/ui-utils");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _this = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AaRadioButton = function AaRadioButton(props) {
  var _useState = (0, _react.useState)(props),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      radioItems = _useState2[0],
      setRadioItems = _useState2[1];

  var onChecked = function onChecked(val) {
    setRadioItems(_objectSpread(_objectSpread({}, radioItems), {}, {
      data: val
    }));
    props.controls.onChecked(val);
  };

  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.radioButtonContainer
  }, radioItems.controls.items.map(function (data, index) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      key: "AaRadioBtn-".concat(data.text, "-").concat(index)
    }, radioItems.data == data.value ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableOpacity, {
      style: [styles.btn, index > 0 ? {
        marginLeft: props.controls.gap
      } : null]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: [styles.radioBtnBorder, styles.radioBtnBorderActive]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.radioBtnChecked
    })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      style: styles.radioStyle
    }, data.text)) : /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableOpacity, {
      onPress: onChecked.bind(_this, data.value),
      style: [styles.btn, index > 0 ? {
        marginLeft: props.controls.gap
      } : null]
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.radioBtnBorder
    }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      style: styles.radioStyle
    }, data.text)));
  }));
};

var styles = _StyleSheet["default"].create({
  radioButtonContainer: {
    flexDirection: 'row'
  },
  btn: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  radioBtnBorder: {
    height: 24,
    width: 24,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: '#bfc5cf',
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 5
  },
  radioBtnBorderActive: {
    borderColor: '#4b4fa6'
  },
  radioBtnChecked: {
    height: 14,
    width: 14,
    borderRadius: parseInt(14, 10) * 0.5,
    backgroundColor: '#4b4fa6'
  },
  radioStyle: {
    fontSize: 16,
    color: '#313541',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '400'
    }
  }
});

var _default = AaRadioButton;
exports["default"] = _default;